import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
// import { VForm, VTextField, VRadioGroup, VRadio, VCheckbox, VAlert } from 'vuetify/lib';
import App from './App.vue';
import router from './router';
import store from './store/index.js';

import {RunConfigService} from '@nuskin/ns-util';
import FeatureFlagPlugin from '@nuskin/ns-feature-flags-vue';

if (process.env.NODE_ENV === 'sbx') {
    RunConfigService.setRunConfig({
        language: 'en',
        country: 'US'
    });
    RunConfigService.setBaseUrl('https://test.nuskin.com');
}
// for the url, use awsUrl for the current context
Vue.use(FeatureFlagPlugin, {
    url: process.env.VUE_APP_FF_ENDPOINT
});

Vue.use(Vuetify, {
    iconfont: 'md'
});

Vue.config.devtools = true;
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');
